import useSWR from "swr";
import { Trophy, Loader2 } from "lucide-react";
import { api } from "../lib/api";

const fmtDay = (d) => new Date(`${d.slice(0, 4)}-${d.slice(4, 6)}-${d.slice(6)}T12:00:00`).toLocaleDateString("it-IT", { weekday: "short", day: "2-digit", month: "short" });
const chipLabel = (s) => (s.target ? `Q${s.target}` : "Corner");

function WinCount({ t }) {
  return (
    <div className="border border-[#27272A] p-4" data-testid={`history-target-${t.target ?? "c3"}`}>
      <div className="label text-[10px]">{t.group || `Quota ${t.target}`}</div>
      <div className="flex items-baseline gap-2 mt-1">
        <span className="heading text-4xl font-black mono text-[#39FF14]" data-testid={`history-won-${t.target ?? "c3"}`}>{t.won}</span>
        <span className="text-xs text-[#A1A1AA]">{t.won === 1 ? "vinta" : "vinte"}</span>
      </div>
    </div>
  );
}

function WinDay({ d, onPickDay }) {
  return (
    <button onClick={() => onPickDay(d.date)} data-testid={`history-day-${d.date}`}
      className="w-full grid grid-cols-[110px_1fr] items-center gap-3 border border-[#27272A] px-3 py-2 hover:border-[#39FF14]/60 transition-colors text-left">
      <span className="mono text-xs capitalize">{fmtDay(d.date)}</span>
      <span className="flex flex-wrap gap-2">
        {d.wins.map((s) => (
          <span key={s.id || s.target} className="mono text-[11px] font-bold px-2 py-0.5 bg-[#39FF14] text-black">
            {chipLabel(s)} · {s.total_odds.toFixed(2)}
          </span>
        ))}
      </span>
    </button>
  );
}

export default function SlipsHistory({ onPickDay }) {
  const { data } = useSWR("slips-history", () => api.get("/slips/history", { params: { days: 30 } }).then((r) => r.data), { refreshInterval: 300000 });
  if (!data) return <Loader2 className="animate-spin text-[#A1A1AA]" />;
  const days = data.history.map((d) => ({ ...d, wins: d.slips.filter((s) => s.status === "won") })).filter((d) => d.wins.length);
  const groups = data.targets.filter((t) => t.won > 0);
  const total = days.reduce((n, d) => n + d.wins.length, 0);
  return (
    <section className="surface-raised p-6 space-y-6" data-testid="slips-history">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div className="label flex items-center gap-2"><Trophy size={12} /> Le nostre vincite · ultimi 30 giorni</div>
        <div className="text-right" data-testid="history-total-wins">
          <div className="label text-[9px]">Schedine vinte</div>
          <div className="heading text-3xl font-black mono text-[#39FF14]">{total}</div>
        </div>
      </div>

      {groups.length > 0 && (
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
          {groups.map((t) => <WinCount key={t.group || t.target} t={t} />)}
        </div>
      )}

      <div>
        <div className="label text-[10px] mb-2">Giorno per giorno</div>
        <div className="space-y-1" data-testid="history-days">
          {days.map((d) => <WinDay key={d.date} d={d} onPickDay={onPickDay} />)}
          {!days.length && <p className="text-sm text-[#A1A1AA]">Le prossime vincite compariranno qui.</p>}
        </div>
      </div>
    </section>
  );
}
